import React, { PropsWithChildren } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { TOP_NAV_SPACING_AFFORDANCE } from 'clipsal-cortex-ui/src/components/MobileTopNav';

import { TopNav } from '../../common/components/TopNav';
import { useViewportType } from '../../common/hooks/use-viewport-type';

type ProfilePageBaseProps = {
  title: string;
  backURL?: string;
  containerProps?: BoxProps & { 'data-testid'?: string };
} & PropsWithChildren;

export const ProfilePageBase = ({ children, title, backURL, containerProps }: ProfilePageBaseProps) => {
  const navigate = useNavigate();
  const { isDesktopViewport } = useViewportType();

  return (
    <Box
      minHeight={isDesktopViewport ? 'calc(100vh - 72px)' : undefined}
      data-testid={`${title.replaceAll(' ', '-').toLowerCase()}-page`}
      {...containerProps}
    >
      <TopNav
        title={title}
        onClickBack={() => (backURL ? navigate(backURL) : navigate(-1))}
        shouldDisplayTitleOnDesktop
      />

      <Box mt={isDesktopViewport ? 3 : TOP_NAV_SPACING_AFFORDANCE}>{children}</Box>
    </Box>
  );
};
